module.exports = __webpack_public_path__ + "static/assets/nadine-primeau-l5Mjl9qH8VU-unsplash.ba3670e5.jpg";